import Vue from "vue";
import Vuex from "vuex";
import { getTopic } from "../../utils/apiFunctions.js";
Vue.use(Vuex);
const state = () => ({
	// TOPIC VUE STATE
	selectedTopic: { topicID: "", topicName: "" },
	isLoadingStatusOne: false,
	showstatisticrecord: [],
});
// sort(initialArray, finalArray)

const getters = {
	// getTopicDetails: state => state.topicDetails,
	getSelectedTopic: (state) => state.selectedTopic,
	getiIsLoadingStatusOne: (state) => state.isLoadingStatusOne,
	getshowstatisticrecord: (state) => state.showstatisticrecord,
};

// actions
const actions = {
	// GET API
	async getTopic(state, payload) {
		try {
			const res = await getTopic(payload);
			if (res.status == 200) {
				const { data } = res;
				let payload = data.data.topicIDs;
				for (let i in payload) {
					payload[i].editoption = false;
				}
				state.commit("saveTopic", payload);
			}
		} catch (error) {
			let payload = [];
			state.commit("saveTopic", payload);
		}
	},
};
// mutations
const mutations = {
	isLoadingStatusOne(state, payload) {
		state.isLoadingStatusOne = payload;
	},
	savegetStatisticReport(state, payload) {
		state.showstatisticrecord = payload;
	},
	// -----------------------
	// ------- TOPIC ---------
	// -----------------------
	saveSelectedTopic(state, payload) {
		state.selectedTopic.topicID = payload.topicID;
		state.selectedTopic.topicName = payload.topicName;
		// Hide The Test Config
		this.state.testVUEX.showTestConfig = false;
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
